import axios from 'axios';
import { API_URL } from './api';
const base = `${API_URL}/api/auth/social`;
export const getSocialProviders = () => axios.get(`${base}/providers/`, { timeout: 10000 }).then(r => r.data);
export const startSocialLogin = provider => axios.post(`${base}/start/${provider}/`, {}, { timeout: 15000 }).then(r => r.data);
export const finishSocialLogin = attempt => axios.post(`${base}/finish/`, {
    attempt: attempt.attempt, secret: attempt.secret, handoff: attempt.handoff || '',
}, { timeout: 15000 }).then(r => r.data);
export const loginMaxWebApp = initData => axios.post(`${base}/max/webapp/`, { init_data: initData }, { timeout: 15000 }).then(r => r.data);
